import { Button, Container } from 'components/atoms';
import { useFormikContext } from 'formik';
import { t } from 'i18next';

import { IFormikContextType } from 'hooks/useFormikField';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { usePostMusicProductDigitalFromVideo } from 'services/video';
import { IVideoMutationForm } from 'services/video/types';

const VideoProducts = () => {
  const { values }: IFormikContextType<IVideoMutationForm> = useFormikContext<IVideoMutationForm>();

  const createFromVideo = usePostMusicProductDigitalFromVideo();

  const handleAddProduct = async () => {
    if (!values?.id) return;

    const mpdId = await createFromVideo.mutateAsync({
      videoId: values.id,
    });
  };

  return (
    <Container>
      <Container.Header title={t('input.label.products')} />

      <Button
        fullWidth
        variant={BUTTON_VARIANT.submit}
        isLoading={createFromVideo.isPending}
        onClick={handleAddProduct}
        disabled={!values?.id}
      >
        {t('input.label.addProduct')}
      </Button>
    </Container>
  );
};

export default VideoProducts;
